import { ChangeDetectionStrategy, Component, computed, inject, input, signal } from '@angular/core';

import { Store } from '@ngrx/store';

import { BookingAppState } from '@fcom/common/interfaces/booking';
import { QualtricsSurveys } from '@fcom/common/qualtrics/qualtrics.utils';
import { orderDataSelector } from '@fcom/common-booking/store';
import { getProductTripTypeFromBoundsForGA4 } from '@fcom/common/utils/gtm.utils';
import { GA4TripType } from '@fcom/common/interfaces';

import { cartDataSelector } from '../../../../store/selectors';

@Component({
  selector: 'fin-multi-city-survey',
  templateUrl: './multi-city-survey.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
  host: {
    '[class]': 'hostClasses()',
  },
})
export class MultiCitySurveyComponent {
  private store$ = inject<Store<BookingAppState>>(Store);

  alwaysRender = input(false);
  extraClasses = input('');

  survey = QualtricsSurveys.MULTI_CITY;
  openSurvey = signal(false);

  private order = this.store$.selectSignal(orderDataSelector);
  private cartData = this.store$.selectSignal(cartDataSelector);

  private cartOrOrder = computed(() => this.order() ?? this.cartData());

  enableSurvey = computed(() => {
    if (this.alwaysRender()) {
      return true;
    }

    const cartOrOrder = this.cartOrOrder();
    if (!cartOrOrder) {
      return false;
    }

    return getProductTripTypeFromBoundsForGA4(cartOrOrder.bounds) === GA4TripType.MULTICITY;
  });

  hostClasses = computed(() => (this.enableSurvey() ? this.extraClasses() : ''));
}
